// extracted by mini-css-extract-plugin
module.exports = {"root":"MergedInvoice_root__viodu","header":"MergedInvoice_header__2wVLQ"};